'use client';

import CampaignBanner from '../../../components/CampaignBanner';
import type { BannerData } from '../../../types';

export interface CapsuleBannerProps {
  data: BannerData;
  isWap: boolean;
  onBannerClick?: (data: BannerData, index: number) => void;
}

/** 胶囊活动页顶部 Banner。 */
export default function CapsuleBanner({ data, isWap, onBannerClick }: CapsuleBannerProps) {
  if (isWap) {
    return (
      <section className="relative w-full bg-white">
        <CampaignBanner
          data={data}
          className="w-full"
          contentClassName="relative block w-full"
          imageClassName="block h-auto w-full object-contain object-center"
          width={375}
          height={180}
          sizes="100vw"
          onBannerClick={onBannerClick}
        />
        {data.sub_title ? (
          <p className="pointer-events-none absolute inset-x-0 bottom-[30px] m-0 break-words text-center font-br text-[14px] font-normal leading-normal text-primary-text">
            {data.sub_title}
          </p>
        ) : null}
      </section>
    );
  }

  return (
    <section className="relative flex w-full flex-col items-center justify-center bg-white">
      <CampaignBanner
        data={data}
        className="w-full"
        contentClassName="relative block w-full"
        imageClassName="block h-auto w-full object-contain object-center"
        width={1920}
        height={254}
        sizes="100vw"
        onBannerClick={onBannerClick}
      />
      {data.sub_title ? (
        <p className="pointer-events-none absolute inset-x-0 bottom-[20px] m-0 break-words text-center font-br text-[14px] font-normal leading-normal text-primary-text min-[1280px]:bottom-[24px] min-[1280px]:text-[20px] min-[1920px]:bottom-[32px]">
          {data.sub_title}
        </p>
      ) : null}
    </section>
  );
}
